import SrSettingTable from "./SrSettingTable.vue";

SrSettingTable.install = function(Vue) {
  Vue.component(SrSettingTable.name, SrSettingTable);
};

export default SrSettingTable;


// WEBPACK FOOTER //
// ./packages/SrSettingTable/index.js